/* mc-reference.js — filtry, načítání dalších a detail reference | mcompanies.cz */
(function () {
  'use strict';

  var modal = null;
  var lastFocused = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'mcr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="mcr-modal__backdrop"></div>' +
      '<div class="mcr-modal__panel">' +
      '<button type="button" class="mcr-modal__close" aria-label="Zavřít">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<div class="mcr-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('.mcr-modal__close')) {
        closeModal();
        return;
      }
      if (!e.target.closest('.mcr-modal__panel')) closeModal();
    });

    return modal;
  }

  function openModal(card) {
    var tpl = card.querySelector('.mcr-card__full');
    if (!tpl || !tpl.content) return;

    lastFocused = document.activeElement;
    var m = buildModal();
    var body = m.querySelector('.mcr-modal__body');
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));

    var styles = getComputedStyle(card);
    ['--mcr-accent', '--mcr-text', '--mcr-line'].forEach(function (prop) {
      var value = styles.getPropertyValue(prop);
      if (value) m.style.setProperty(prop, value.trim());
    });

    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    m.querySelector('.mcr-modal__close').focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  function initSection(root) {
    if (!root || root.getAttribute('data-mcr-ready') === '1') return;
    root.setAttribute('data-mcr-ready', '1');

    var cards = Array.prototype.slice.call(root.querySelectorAll('.mcr-card'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('.mcr-filter'));
    var reset = root.querySelector('.mcr__reset');
    var more = root.querySelector('.mcr__more');
    var empty = root.querySelector('.mcr__empty');
    var step = parseInt(root.getAttribute('data-step'), 10) || 6;
    var cardLink = root.getAttribute('data-cardlink') === 'true';
    var shown = step;

    function matches(card) {
      for (var i = 0; i < filters.length; i++) {
        var val = filters[i].value;
        if (!val) continue;
        var key = filters[i].getAttribute('data-key');
        var raw = card.getAttribute('data-' + key) || '';
        if (raw.split('|').indexOf(val) === -1) return false;
      }
      return true;
    }

    function render() {
      var total = 0;
      var visible = 0;

      cards.forEach(function (card) {
        if (matches(card)) {
          total++;
          if (visible < shown) {
            card.hidden = false;
            visible++;
          } else {
            card.hidden = true;
          }
        } else {
          card.hidden = true;
        }
      });

      if (empty) empty.hidden = total !== 0;
      if (more) more.hidden = total <= visible;
      if (reset) {
        reset.hidden = !filters.some(function (f) {
          return f.value !== '';
        });
      }
    }

    filters.forEach(function (f) {
      f.addEventListener('change', function () {
        shown = step;
        render();
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        filters.forEach(function (f) {
          f.value = '';
        });
        shown = step;
        render();
      });
    }

    if (more) {
      more.addEventListener('click', function () {
        shown += step;
        render();
      });
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('.mcr-card');
      if (!card) return;

      if (e.target.closest('.mcr-card__detail')) {
        e.preventDefault();
        openModal(card);
        return;
      }

      if (e.target.closest('a, button')) return;

      if (card.querySelector('.mcr-card__full')) {
        openModal(card);
        return;
      }

      if (cardLink && card.getAttribute('data-href')) {
        window.location.href = card.getAttribute('data-href');
      }
    });

    root.mcrShowAll = function () {
      shown = cards.length;
      filters.forEach(function (f) {
        f.value = '';
      });
      render();
    };

    render();
  }

  function initAll() {
    document.querySelectorAll('.mcr').forEach(function (root) {
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.mcr');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest ? e.target.closest('.mcr-card') : null;
    if (!card) return;
    var root = card.closest('.mcr');
    if (root && root.mcrShowAll) root.mcrShowAll();
    card.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
})();


